/*--------------------------------------
	불러톡 — 렌더/스크롤 (ChatDraw)

	메세지 말풍선 빌드 + 스크롤 컨테이너/옵저버 + 전송버튼/입력창 표시.
	상태는 메인 Chat(this.chat)이 보유하며, 여기서는 그것을 읽고 갱신한다.
--------------------------------------*/
import Util from '../../Common/Util';
import Store from '../../Common/Store';


const HTML_ESCAPE = { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;', '/':'&#x2F;' };

/** 말풍선에 들어가는 평문 이스케이프. Socket 이 수신문자열에도 쓴다 */
export function htmlspecialchars(str) {
    return String(str).replace(/[&<>"'/]/g, m => HTML_ESCAPE[m]);
}

export default class ChatDraw {
	/**
	 * @param chat 메인 Chat 인스턴스(상태 공유)
	 */
	constructor(chat){
		this.chat = chat;
	}

	/**
	 * 소켓 수신 메세지 1건 처리 — 그린 뒤 필요 시 하단으로 스크롤.
	 * @param data 메세지
	 */
	onRecvMsg(data){
		this.showSendBtn();
		this.clearTypingFor(data.sender_name); // 그 사람 메시지 도착 → 입력중에서 제외(다른 사람은 유지)
		const isBottom = this.isScrollBottom(); // 원래 하단이었는지
		this.drawOne(data);
		// 원래 하단이었거나 내가 보낸 메시지면 하단으로
		if( isBottom || data.sender_num == this.chat.userNum ) this.scrollToBottom();
		this.updateRecoTray(); // 마지막 메시지 기준 추천답변 트레이 재평가(회원이 마지막이면 노출)
	}

	/**
	 * 부재중(에티켓 시간) 자동답변 — 방주인(회원)이 업무시간 외 작성 시
	 * 소켓 브로드캐스트 없이 내 화면에만 그린다 (DB 저장 안 함, 상대에게도 안 감).
	 * 문구는 페이지 렌더 시 주입(chat.chatAbsentMsg, 자동답변 상황코드 101).
	 * @param id 직전 메세지 PK
	 */
	showAbsentReply(id){
		const chat = this.chat;
		if( !chat.chatAbsentMsg ) return;
		if( chat.absentSent ) return;            // 세션당 1회만 (회원이 연속 전송해도 반복 안 함)
		if( chat.roomno != chat.myMbno ) return; // 방주인(회원)이 아니면(=상담원) 제외
		if( !this.isAbsentTime() ) return;        // 업무시간엔 미발송
		chat.absentSent = true;                   // 표시함 — 이 세션에선 다시 안 그림
		// 내가 보낸 메시지(소켓 echo)가 먼저 그려지도록 살짝 지연 후 append.
		setTimeout(() => {
			this.onRecvMsg({
				isTalkManager: 1,                 // 관리자 말풍선(좌측·딥컬러)
				sent_date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
				sender_num: 0,
				sender_name: '관리자',
				num: 'absent_' + id,
				msg: chat.chatAbsentMsg,
				body: { t: 'text', text: chat.chatAbsentMsg },
			});
		}, 700);
	}

	/**
	 * 부재중 시간대(에티켓 타임) 여부 — 업무 07:30~20:00 외엔 true.
	 * @return bool
	 */
	isAbsentTime(){
		const t = dayjs().format('HH:mm');
		if( '07:30' < t && t < '20:00' ) return false; // 업무시간
		return true;
	}


	/**
	 * 에티켓 시간 안내 배너 — 방주인(회원)이 업무시간 외 채팅창에 진입하면
	 * 입력창 바로 위에 안내 박스를 고정한다. X 로 닫으면 사라지지만
	 * 닫힘 상태는 저장하지 않아, 채팅창을 다시 열면(init 재실행) 다시 뜬다.
	 */
	showAbsentBanner(){
		const chat = this.chat;
		if( chat.isAdminPage ) return;              // 상담원(관리자) 화면 제외 — 고객에게만
		if( chat.roomno != chat.myMbno ) return;    // 방주인(회원)이 아니면(=상담원) 제외
		if( !this.isAbsentTime() ) return;           // 업무시간엔 미표시
		if( $('#chatAbsentBanner').length ) return;  // 중복 방지

		$('body').append(
			'<div id="chatAbsentBanner" class="chat-absent-banner">'
			+ '<span class="chat-absent-banner__text">📢 에티켓 시간입니다 · 상담가능 07:30~20:00</span>'
			+ '<button type="button" class="chat-absent-banner__close js-chat-absent-close" aria-label="닫기">&times;</button>'
			+ '</div>'
		);
		this.positionAbsentBanner(); // 입력창 바로 위에 고정
		this.resizeScroll();          // 배너 높이만큼 대화창 높이 재계산
	}

	/** 에티켓 배너(fixed)를 입력창 바로 위에 위치시킴 (입력창 높이에 동기화) */
	positionAbsentBanner(){
		const $b = $('#chatAbsentBanner');
		if( !$b.length ) return;
		$b.css('bottom', ($('#keyinputBoxdiv').outerHeight() || 0) + 'px');
	}

	/** 저장된 빠른답변(내 템플릿) 적재 — 렌더는 showQuickTray. */
	setQuickTemplates(list){
		this.chat.quickTemplates = list || [];
	}

	/** 번개 아이콘 SVG (트레이 헤더용) */
	zapIcon(){
		return '<svg class="chat-tray__zap" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">'
			+ '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>';
	}

	/**
	 * 추천답변(초록·자동) 트레이 — 기본(쉬는) 상태. 관리자만. 입력창 비었을 때 노출.
	 */
	showRecoTray(){
		const chat = this.chat;
		if( !chat.isTrayOn ) return;
		this.trayMode = 'reco';
		const chips = (chat.recoReplies || []).map(r =>
			`<button type="button" class="chat-chip chat-chip--reco js-chat-send-chip" data-content="${this.escHtml(r.content)}">${this.escHtml(r.label)}</button>`
		).join('');
		$('#chatReplyTray').html(
			'<div class="chat-tray__head chat-tray__head--reco"><span class="chat-tray__dot"></span>추천 답변</div>'
			+ '<div class="chat-tray__chips">' + chips + '</div>'
		).css('display', 'flex'); // flex 칸 — show() 는 block 으로 연다 (처음 숨김은 _chat-room.scss)
		this.afterTrayChange();
	}

	/**
	 * 빠른답변(노랑·내 템플릿) 트레이 — 번개 탭 시. 관리자만.
	 */
	showQuickTray(){
		const chat = this.chat;
		if( !chat.isTrayOn ) return;
		this.trayMode = 'quick';
		const list = chat.quickTemplates || [];
		// 형식을 칩에 표시한다 — 평문은 입력창에 채워지고, 서식글·이미지는 미리보기를 거친다.
		// 누르면 무엇이 일어나는지가 갈리므로 누르기 전에 보여야 한다.
		const chips = list.length
			? list.map((k, i) => {
				const mark = k.body_type === 'img' ? '🖼 ' : (k.body_type === 'html' ? '📄 ' : '');
				return `<button type="button" class="chat-chip chat-chip--quick js-chat-chip" data-i="${i}">${mark}${this.escHtml(k.title)}</button>`;
			}).join('')
			: '<span class="chat-tray__empty">저장된 빠른답변이 없습니다</span>';
		$('#chatReplyTray').html(
			'<div class="chat-tray__head chat-tray__head--quick">' + this.zapIcon() + '내 빠른답변 · 고르면 입력창에서 수정 후 전송</div>'
			+ '<div class="chat-tray__chips">' + chips + '</div>'
		).css('display', 'flex'); // flex 칸 — show() 는 block 으로 연다 (처음 숨김은 _chat-room.scss)
		this.afterTrayChange();
	}

	/**
	 * 빠른답변 미리보기 — 서식글·이미지는 입력창에 담을 수 없어 여기서 고른다.
	 *
	 * 트레이 자리를 그대로 쓴다. 별도 시트를 띄우면 모바일관리자(/ma)·관리자 팝업(/adm/chat)·
	 * 회원앱 셋이 각자 다른 컴포넌트를 갖게 되는데, 이 자리는 이미 셋이 공유한다.
	 */
	showQuickPreview(i){
		const k = (this.chat.quickTemplates || [])[i];
		if( !k ) return;
		this.trayMode = 'quick';

		let body;
		if( k.body_type === 'img' ){
			body = '<div class="chat-tray__thumbs">'
				+ (k.images || []).map(im => `<img src="${this.escHtml(im.url)}" alt="">`).join('')
				+ `</div><div class="chat-tray__count">이미지 ${(k.images || []).length}장 — 좌우로 넘기는 카드 한 건으로 나갑니다</div>`;
		} else {
			// 서식글도 미리보기는 평문으로 — 트레이 안에서 남의 서식을 그리면 줄높이가 튄다
			body = `<div class="chat-tray__text">${this.escHtml(k.content)}</div>`;
		}

		$('#chatReplyTray').html(
			'<div class="chat-tray__head chat-tray__head--quick">'
			+ '<button type="button" class="chat-tray__back js-chat-quick-back" aria-label="목록으로">‹</button>'
			+ this.escHtml(k.title) + '</div>'
			+ body
			+ '<div class="chat-tray__acts">'
			+ `<button type="button" class="chat-tray__btn chat-tray__btn--go js-chat-quick-send" data-i="${i}">이대로 보내기</button>`
			+ (k.body_type === 'img' ? ''
				: `<button type="button" class="chat-tray__btn js-chat-quick-fill" data-i="${i}">입력창에 넣기</button>`)
			+ '</div>'
		).show();
		this.afterTrayChange();
	}

	/** 트레이 숨김(칩 선택 시). */
	hideTray(){
		this.trayMode = null;
		$('#chatReplyTray').empty().hide();
		this.afterTrayChange();
	}

	/**
	 * 추천답변 트레이 노출 판정 — 마지막 메시지가 회원(방주인)일 때만 노출, 관리자가 답하면 숨김.
	 * (빠른답변 열림/입력 중일 땐 건드리지 않음)
	 */
	updateRecoTray(){
		const chat = this.chat;
		if( !chat.isTrayOn ) return;
		if( this.trayMode === 'quick' ) return;                          // 빠른답변 열려있으면 유지
		if( $.trim($('#sendmessagcont').val()).length > 0 ) return;      // 입력(삭제상태) 중이면 유지
		const $last = $('#content_list > .chat-row:not(#chatTyping)').last();
		const lastMb = $last.length ? String($last.attr('data-mbno')) : '';
		const isCustomerLast = ( lastMb !== '' && lastMb === String(chat.roomno) ); // 마지막이 회원(방주인)
		if( isCustomerLast ) this.showRecoTray();
		else                 this.hideTray();
	}

	/** 트레이 표시/숨김 후 공통 — 위치·높이·버튼·입력중 표시 갱신 */
	afterTrayChange(){
		this.positionTray();
		this.updateZapBtn();
		this.resizeScroll();
		this.positionTyping();
	}

	/** 트레이(fixed)를 입력창 바로 위에 위치시킴 (입력창 높이에 동기화) */
	positionTray(){
		const $t = $('#chatReplyTray');
		if( !$t.length || $t.css('display') === 'none' ) return;
		$t.css('bottom', ($('#keyinputBoxdiv').outerHeight() || 0) + 'px');
	}

	/** 번개/삭제 버튼 상태 — 입력 유무 + 트레이 모드 기준(삭제 > 활성 > 비활성) */
	updateZapBtn(){
		if( !this.chat.isTrayOn ) return;
		const hasText = $.trim($('#sendmessagcont').val()).length > 0;
		$('#chatZapBtn')
			.toggleClass('is-del', hasText)                              // 글자 있으면 삭제(×)
			.toggleClass('is-active', !hasText && this.trayMode === 'quick'); // 빠른답변 열림 = 번개 활성
	}

	/**
	 * 입력중(typing) 표시 — 관리자끼리만. 대화 하단에 프사 + 텍스트 한 줄로 안내(말풍선 없음).
	 *  · 1명    : "○○님이 현재 입력중입니다"
	 *  · 2명이상: "○○님 외 N명이 현재 입력중입니다" (프사는 대표(첫) 입력자 것)
	 * 이름별로 3초 타이머를 두어 조용해진 사람은 자동 제외, 아무도 없으면 사라짐.
	 * @param name 입력중인 관리자 이름
	 * @param profileImg 프사 URL — 없으면 이름 이니셜로 대체
	 */
	showTyping(name, profileImg){
		if( !this.chat.isAdminPage ) return; // 관리자 화면에서만
		name = name || '상담원';
		if( !this._typing ) this._typing = {};       // name → 만료 타이머
		if( !this._typingImg ) this._typingImg = {}; // name → 프사 URL

		clearTimeout(this._typing[name]);
		this._typingImg[name] = profileImg || '';
		this._typing[name] = setTimeout(() => {
			delete this._typing[name];
			delete this._typingImg[name];
			this.renderTyping();
		}, 3000);
		this.renderTyping();
	}

	/**
	 * 현재 입력중 집합으로 표시 갱신(없으면 제거).
	 * 입력창 바로 위에 fixed 로 고정 — 대화창을 위로 스크롤해도 항상 보인다(스크롤 영역 밖).
	 * 등장/소멸 시 resizeScroll() 로 대화창 높이를 다시 잡아 위로 밀어준다(뒤 대화 가림 방지).
	 */
	renderTyping(){
		const names = this._typing ? Object.keys(this._typing) : [];
		if( !names.length ){
			if( $('#chatTyping').length ){ $('#chatTyping').remove(); this.resizeScroll(); }
			return;
		}

		const primary = names[0]; // 대표(첫) 입력자 — 프사·이름 기준
		const label = (names.length === 1)
			? primary + '님이 현재 입력중입니다'
			: primary + '님 외 ' + (names.length - 1) + '명이 현재 입력중입니다';

		const img = this._typingImg ? this._typingImg[primary] : '';
		const avatarInner = img
			? `<img src="${this.escHtml(img)}" alt="">`
			: `<span>${this.escHtml(String(primary).slice(0, 3))}</span>`;

		const isNew = !$('#chatTyping').length;
		if( isNew ){
			$('body').append(
				'<div id="chatTyping" class="chat-typing">'
				+ '<div class="chat-avatar chat-avatar--mgr" id="chatTypingAvatar"></div>'
				+ '<div class="chat-typing__name" id="chatTypingName"></div>'
				+ '</div>'
			);
		}
		$('#chatTypingAvatar').html(avatarInner);
		$('#chatTypingName').text(label);
		this.positionTyping();
		if( isNew ) this.resizeScroll();
	}

	/** 입력중 표시(fixed)를 입력창(+빠른답장) 바로 위에 위치시킴 */
	positionTyping(){
		const $t = $('#chatTyping');
		if( !$t.length ) return;
		let bottom = $('#keyinputBoxdiv').outerHeight() || 0;
		const $tray = $('#chatReplyTray');
		if( $tray.length && $tray.css('display') !== 'none' ) bottom += $tray.outerHeight() || 0; // 트레이가 있으면 그 위에 쌓기
		$t.css('bottom', bottom + 'px');
	}

	/** 특정 이름을 입력중 집합에서 제거 — 그 사람 메시지가 도착하면 호출 */
	clearTypingFor(name){
		if( !this._typing || !name || !this._typing[name] ) return;
		clearTimeout(this._typing[name]);
		delete this._typing[name];
		if( this._typingImg ) delete this._typingImg[name];
		this.renderTyping();
	}

	/** 입력중 표시 전체 제거 */
	hideTyping(){
		if( this._typing ){
			for( const k in this._typing ) clearTimeout(this._typing[k]);
			this._typing = {};
		}
		this._typingImg = {};
		if( $('#chatTyping').length ){ $('#chatTyping').remove(); this.resizeScroll(); }
	}


	/**
	 * 위로 스크롤 추가로딩 옵저버 — #top-observer 가 보이면 getMoreTalk.
	 * @param target 관찰 대상 엘리먼트
	 */
	initObserver(target){
		const chat = this.chat;
		if( chat.observer ) chat.observer.disconnect(); // 중복 방지
		chat.observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if( entry.isIntersecting && chat.ongetting === 0 && chat.firstRsno !== 0 ) chat.ajax.getMoreTalk();
			});
		}, { root: $('#talkList_inside')[0], rootMargin: '300px', threshold: 0 });
		chat.observer.observe(target);
	}

	/**
	 * 스크롤 컨테이너(#talkList_inside) 셋업 — adm/일반 공통.
	 * 일반 흐름(위→아래): 적으면 상단부터 쌓이고, 많으면 scrollToBottom 으로 최신까지 내린다.
	 */
	setupScroll(){
		const self = this;
		const $el = $('#talkList_inside');
		if( !$el.length ) return;
		$el.css({ overflowY:'auto', position:'relative' });
		this.resizeScroll();
		setTimeout(() => self.resizeScroll(), 300); // 팝업이 최종 크기로 잡힌 뒤 높이 재계산(하단 흰틈 방지)
		$(window).off('resize.chat').on('resize.chat', () => self.resizeScroll());
		this.setupPinBottom($el[0]);
	}

	/**
	 * 바닥 고정 — 맨 아래를 보고 있는 동안에는 내용이 늦게 길어져도 맨 아래를 유지한다.
	 *
	 * 사진·카드뉴스는 높이 없이 그려져 로드가 끝나야 자리를 차지한다. scrollToBottom 은 그 전에
	 * 끝나 있으므로, 그대로 두면 최신 메시지가 입력창 아래로 밀려 화면이 위로 올라간 것처럼 보인다.
	 *
	 * 고정(_pin)은 scrollToBottom 이 켜고, **사람이 스크롤해 바닥을 떠나면** 꺼진다. 스크롤 이벤트만
	 * 봐서는 사람이 올린 것인지 내용이 길어져 밀린 것인지 가를 수 없어, 입력(터치·휠·키·마우스)이
	 * 있었던 직후의 스크롤만 사람 것으로 친다.
	 */
	setupPinBottom(el){
		if( this._pinBound ) return;
		this._pinBound = true;

		let userAt = 0, holding = false;
		const touch = () => { userAt = Date.now(); };
		$(el).on('touchstart.chatpin mousedown.chatpin', () => { holding = true; touch(); })
			.on('touchmove.chatpin wheel.chatpin keydown.chatpin', touch)
			.on('scroll.chatpin', () => {
				if( holding || Date.now() - userAt < 1500 ) this._pin = this.isScrollBottom();
			});
		$(window).on('touchend.chatpin touchcancel.chatpin mouseup.chatpin', () => { holding = false; touch(); });

		const stick = () => { if( this._pin ) el.scrollTop = el.scrollHeight; };
		const list = $('#content_list')[0];
		if( typeof ResizeObserver === 'function' && list ) new ResizeObserver(stick).observe(list);
		else el.addEventListener('load', stick, true); // 미지원 웹뷰 — 이미지 로드만이라도 (load 는 버블하지 않아 캡처로)
	}

	/**
	 * 컨테이너 높이를 "현재 위치 ~ 하단 고정 입력창 위"까지 실측 계산.
	 *
	 * ⚠ 단위를 맞춰야 한다 — 글자크기 확대는 body 에 zoom 을 건다(mobile/base/_fontsize.scss).
	 *   window.innerHeight · getBoundingClientRect() : '확대된' 픽셀
	 *   jQuery outerHeight() · css('height')         : 확대 전(레이아웃) 픽셀
	 *   섞어 계산한 값을 확대 전 단위로 적용하면 컨테이너가 배율만큼 길어져, 마지막 말풍선·
	 *   이미지가 입력창 아래로 내려가 잘렸다 (실측 아주크게 1.4배에서 314px 초과).
	 *   → 뷰포트 쪽 값을 실효 배율로 나눠 레이아웃 픽셀로 환산한 뒤 계산한다.
	 *
	 *   배율은 '렌더폭 ÷ 레이아웃폭' 으로 직접 잰다. zoom 이 어디에 걸렸든 맞고,
	 *   확대가 없는 화면(관리자 상담 등)에서는 1 이 되어 기존과 동일하다.
	 */
	resizeScroll(){
		const el = $('#talkList_inside')[0];
		if( !el ) return;
		const inputH = $('#keyinputBoxdiv').outerHeight() || 0;
		const $bar = $('#chatReplyBar');
		const barH = ( $bar.length && $bar.css('display') !== 'none' ) ? ($bar.outerHeight() || 0) : 0;
		const $absent = $('#chatAbsentBanner');
		const absentH = $absent.length ? ($absent.outerHeight() || 0) : 0; // 입력창 위 에티켓 배너
		const $tray = $('#chatReplyTray');
		const trayH = ( $tray.length && $tray.css('display') !== 'none' ) ? ($tray.outerHeight() || 0) : 0; // 입력창 위 추천/빠른답변 트레이
		const $typing = $('#chatTyping');
		const typingH = $typing.length ? ($typing.outerHeight() || 0) : 0; // 입력중 표시 — 대화를 가리지 않게 그만큼 밀어올림

		// 높이가 줄면 스크롤 위치는 그대로라 최신 메시지가 아래로 밀린다.
		// 바닥에 있던 경우엔 바닥을 유지한다 (글자크기를 키우는 순간이 대표적).
		const wasBottom = this.isScrollBottom();

		const rect  = el.getBoundingClientRect();
		const scale = el.offsetWidth ? (rect.width / el.offsetWidth) : 1;
		const top   = rect.top / scale;
		const h = window.innerHeight / scale - top - inputH - barH - absentH - trayH - typingH;
		if( h > 0 ) $(el).css({ height: h+'px', maxHeight: h+'px' });

		if( wasBottom ) this.scrollToBottom();
	}

	/**
	 * 최신(하단)으로 스크롤.
	 */
	scrollToBottom(){
		const $el = $('#talkList_inside');
		if( !$el.length ) return;
		const go = () => $el.scrollTop($el.prop('scrollHeight'));
		this._pin = true; // 이후 늦게 길어지는 내용(사진 로드 등)에도 바닥 유지 — setupPinBottom
		go();
		setTimeout(go, 300); // 톡 많은 방: 렌더 후 높이 늦게 잡혀 한 번 더 보정
	}

	/**
	 * 최신(마지막) 메시지가 컨테이너 하단 근처에 보이는지.
	 * @return bool
	 */
	isScrollBottom(){
		const el = $('#talkList_inside')[0];
		const last = $('#content_list').children().last()[0];
		if( !el || !last ) return true;
		return last.getBoundingClientRect().bottom <= el.getBoundingClientRect().bottom + 60;
	}

	/**
	 * 과거 목록 prepend 렌더.
	 * @param list 최신→과거 순 배열
	 */
	drawList(list){
		const self = this;
		const chat = this.chat;
		// 보던 자리 유지용 기준점 — 붙이기 전 맨 위 항목. 과거 목록이 그 위에 쌓인 만큼 스크롤을 되돌린다.
		// 스크롤 주인은 window 가 아니라 #talkList_inside 다 (setupScroll).
		const el = $('#talkList_inside')[0];
		const anchor = $('#content_list').children().not('#top-observer').first()[0];
		const anchorTopBefore = anchor ? anchor.getBoundingClientRect().top : 0;

		// top-observer 재배치/생성
		const $observerEl = $('#top-observer');
		if( $observerEl.length ){
			$observerEl.remove();
			$('#content_list').prepend($observerEl);
		} else {
			const $observer = $('<div id="top-observer" style="height:1px;opacity:0"></div>');
			$('#content_list').prepend($observer);
			this.initObserver($observer[0]); // 최초 연결
		}

		$.each(list, function(i, row){
			const newDate = dayjs(row.sent_date).format('YYYY-MM-DD');
			if( chat.firstDate && chat.firstDate != newDate ) $('#content_list').prepend( self.dateLine(chat.firstDate) );
			chat.firstDate = newDate;
			$('#content_list').prepend( self.talkBox(row) );
		});

		this.groupRows();
		this.applyFold();
		this.initCards();

		// 스크롤 위치 보정 — 기준점이 밀린 만큼만. 브라우저가 이미 맞춰줬으면(scroll anchoring) 차이가 0 이다.
		// getBoundingClientRect 는 확대된 픽셀, scrollTop 은 레이아웃 픽셀이라 배율로 환산한다 (resizeScroll 참고).
		if( el && anchor ){
			const scale = el.offsetWidth ? (el.getBoundingClientRect().width / el.offsetWidth) : 1;
			const moved = (anchor.getBoundingClientRect().top - anchorTopBefore) / scale;
			if( moved ) el.scrollTop += moved;
		}
	}

	/**
	 * 수신 메세지 1건 append 렌더.
	 * @param row 메세지
	 */
	drawOne(row){
		const chat = this.chat;
		const newDate = dayjs(row.sent_date).format('YYYY-MM-DD');
		if( chat.lastDate && chat.lastDate != newDate ) $('#content_list').append( this.dateLine(newDate) );
		chat.lastDate = newDate;
		$('#content_list').append( this.talkBox(row) );
		this.groupRows();
		this.applyFold();
		this.initCards();
	}

	/**
	 * 날짜 변경선 HTML.
	 * @param date
	 * @return string
	 */
	dateLine(date){
		return `<div class="chat-date"><span>${dayjs(date).format('YYYY년 MM월 DD일 dddd')}</span></div>`;
	}

	/**
	 * 저장된 관리자 메시지 본문의 인라인 글씨색(color) 제거 — 말풍선 기본 글씨색을 따르게 한다.
	 * 과거 리치텍스트 에디터로 박힌 color:#…(검정 등)가 어두운 말풍선과 충돌하는 문제 방지.
	 * background-color 등 다른 선언은 보존.
	 * @return string
	 */
	stripInlineColor(html){
		return html.replace(/([;\s"']|^)color\s*:\s*[^;"']*;?/gi, '$1');
	}

	/** 속성/텍스트용 HTML 이스케이프 */
	escHtml(s){
		return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
	}

	/**
	 * 구조화 JSON body → 말풍선 내부 HTML. (특수태그 없이 타입별 생성)
	 *  · img   : 이미지(클릭=새창)            · audio : 오디오 플레이어
	 *  · order : 텍스트 + 오더수정 링크        · text  : 텍스트
	 * @param body {t, ...}
	 * @param isManager 관리자 메시지 여부(텍스트 처리 분기)
	 * @return string
	 */
	renderBody(body, isManager){
		switch( body && body.t ){
			case 'img':
				return `<img src='${this.escHtml(body.url)}' style='width:100%' class='js-chat-image' id='chatImage_${parseInt(body.id) || 0}'>`;
			case 'audio':
				return `<audio controls preload='none' class='chat-audio' src='${this.escHtml(body.url)}'></audio>`;
			case 'cards':
				return this.renderCards(body.items || []);
			case 'order':
				return this.renderText(body.text, isManager)
					+ `<a href="javascript:void(0)" class="js-chat-order" data-mbno="${parseInt(body.mb) || 0}" data-ordernum="${parseInt(body.order) || 0}">[오더수정]</a>`;
			default: // text
				return this.renderText(body ? body.text : '', isManager);
		}
	}

	/**
	 * 이미지 카드 — **한 톡 = 한 카드**, 안에서 좌우로 넘긴다.
	 *
	 * 장당 말풍선으로 흘리지 않는 이유: 공지·이벤트 한 건이 대화창을 여러 칸 차지해 앞뒤 대화가 묻힌다.
	 * Swiper 는 `dist/vendor.js` 에 들어 있고 대화창을 여는 셋(/adm/chat·/m·/ma)이 모두 싣는다.
	 * 한 장짜리는 넘길 것이 없으므로 캐러셀을 만들지 않는다(점·화살표가 군더더기가 된다).
	 *
	 * 실제 초기화는 렌더 뒤에 해야 한다(DOM 이 붙어야 폭을 잴 수 있다) — initCards 가 맡는다.
	 */
	renderCards(items){
		if( !items.length ) return '';
		// 원본 주소를 카드에 실어 둔다 — 뷰어는 큰 그림으로 연다(목록용 리사이즈본이 아니라)
		const data = this.escHtml(JSON.stringify(items.map(it => ({ url: it.url }))));
		// ⚠ `js-chat-image`/`chatImage_` 를 달지 않는다. 그 표식은 **대화창 사진 갤러리**($j.Ui.ZoomPhoto)가
		//   화면의 사진을 전부 긁어모을 때 쓰는 것이라, 카드 장이 섞이면 '이 카드묶음'이라는 단위가 사라진다.
		//   카드는 자기 묶음만 읽는 전용 뷰어($j.Ui.CardNews)로 연다.
		const img = (it) => `<img src="${this.escHtml(it.url)}" class="js-chat-card-image" alt="">`;

		// 눌러서 커진다는 것을 적어 둔다 — 안 적으면 그냥 그림인 줄 알고 안 누른다.
		// 한 장짜리도 마찬가지라(넘길 게 없을 뿐 확대는 된다) 장수와 상관없이 붙인다.
		const zoomIcon = '<svg class="chat-cards__zoom" viewBox="0 0 24 24" width="11" height="11" aria-hidden="true">'
			+ '<circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="21" y2="21"></line>'
			+ '<line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';

		if( items.length === 1 ){
			return `<div class="chat-cards chat-cards--one js-chat-cards-open" data-cards="${data}">
	${img(items[0])}
	<div class="chat-cards__count">${zoomIcon}크게보기</div>
</div>`;
		}

		return `
<div class="chat-cards js-chat-cards" data-cards="${data}">
	<div class="swiper chat-cards__sw">
		<div class="swiper-wrapper">
			${items.map(it => `<div class="swiper-slide">${img(it)}</div>`).join('')}
		</div>
		<div class="chat-cards__pg swiper-pagination"></div>
		<button type="button" class="chat-cards__nav chat-cards__nav--prev" aria-label="이전">‹</button>
		<button type="button" class="chat-cards__nav chat-cards__nav--next" aria-label="다음">›</button>
	</div>
	<div class="chat-cards__count">${zoomIcon}크게보기 <b>1</b> / ${items.length}</div>
</div>`;
	}

	/**
	 * 카드 캐러셀 초기화 — 아직 안 만든 것만. 말풍선은 여러 경로로 그려지므로(첫 로딩·더보기·소켓)
	 * 그릴 때마다 부르고, 여기서 한 번만 만들게 막는다.
	 */
	initCards(){
		if( typeof Swiper === 'undefined' ) return;   // 번들이 없는 환경 — 첫 장만 보인다(슬라이드도 그냥 쌓임)
		$('.js-chat-cards').each(function(){
			const $c = $(this);
			if( $c.data('swiper') ) return;
			const $count = $c.find('.chat-cards__count b');
			const sw = new Swiper($c.find('.chat-cards__sw')[0], {
				spaceBetween: 8,
				// ⚠ **끄지 말 것.** 없으면 캐러셀 높이가 '가장 긴 장'에 고정돼, 세로가 짧은 장
				//    (가로사진)에서 카드 배경(#FFFFFF)이 아래로 남는다 — 사진마다 빈 띠가 생긴다.
				autoHeight: true,
				// 말풍선은 접기·높이 재계산으로 폭이 바뀐다 — 관찰해서 스스로 다시 잰다
				observer: true,
				observeParents: true,
				pagination: { el: $c.find('.chat-cards__pg')[0], clickable: true },
				navigation: {
					prevEl: $c.find('.chat-cards__nav--prev')[0],
					nextEl: $c.find('.chat-cards__nav--next')[0],
				},
				on: { slideChange: function(){ $count.text(this.realIndex + 1); } },
			});
			$c.data('swiper', sw);

			// ⚠ **이미지가 실린 뒤 다시 재야 한다.** 초기화 시점엔 아직 안 실려 슬라이드 폭이 0 이고,
			//    그러면 스냅 지점이 하나로 접혀 **점 인디케이터가 아예 안 생긴다**(넘기지도 못한다).
			//    높이도 같이 다시 잰다(autoHeight) — 안 실린 상태로 잰 높이는 0 이다.
			$c.find('img').each(function(){
				if( this.complete ) return;
				$(this).one('load error', () => { sw.update(); sw.updateAutoHeight(0); });
			});
		});
	}

	/**
	 * 텍스트 본문 — 일반유저 태그제거 / 관리자 인라인색제거 → 줄바꿈.
	 * @return string
	 */
	renderText(text, isManager){
		let t = String(text == null ? '' : text);
		// 멤버 본문: 이스케이프(꺾쇠 < > 보존 + 태그/XSS 차단). 관리자: 리치텍스트 유지(색만 제거)
		if( !isManager ) t = htmlspecialchars(t);
		else             t = this.stripInlineColor(t);
		return Util.nl2br(t);
	}

	/**
	 * 추천답변 ✅(확인) 시스템 라인 — 말풍선이 아닌 가운데 정렬 확인표시.
	 *  data-mbno 는 보낸이(관리자)로 둬 마지막메시지 판정(추천트레이 숨김)이 정상 동작.
	 * @param data 메세지
	 * @return string
	 */
	confirmRow(data){
		return `
<div class="chat-row chat-row--system" data-mbno="${data.sender_num}" data-num="${parseInt(data.num) || 0}">
	<div class="chat-system"><span class="chat-system__ic">✅</span>관리자가 확인했습니다</div>
</div>`;
	}

	/**
	 * 말풍선 1건 HTML.
	 *  좌/우: 회원뷰=내것만 우측 / 관리자뷰=관리자(우리편) 우측·고객 좌측
	 *  색: 내것=옐로우, 다른관리자(관리자뷰)=딥(모두 동일), 관리자메시지(회원뷰)=딥, 회원=흰색
	 *  연속(같은 사람·같은 분) 이름/시간 접기는 groupRows() 가 처리.
	 *  스타일: shared/components/_chat-room.scss (.chat-* 클래스)
	 * @param data 메세지
	 * @return string
	 */
	talkBox(data){
		const chat = this.chat;
		dayjs.locale('ko');
		const time = dayjs(data.sent_date).format('A h:mm').replace('AM','오전').replace('PM','오후');
		const minute = dayjs(data.sent_date).format('YYYY-MM-DD HH:mm'); // 그룹핑 키
		const isMe = (chat.userNum == data.sender_num);
		const isManager = (data.isTalkManager == 1);
		const deletedMode = parseInt(data.deleted) || 0; // 0:정상 1:관리자뷰(원문+태그) 2:회원뷰(툼스톤)
		const isDeleted = deletedMode > 0;
		const viewerIsAdmin = (chat.isTalkAdmin == 1) || chat.isAdminPage || (chat.isChatAdmin == 1); // 관리자 페이지 / 관리자가 유저톡 대리로 보는 중이면 관리자 뷰(각자 이름)
		const isCustomer = (data.sender_num == chat.roomno);   // 이 메시지 = 방주인 것
		const viewerIsOwner = (chat.userNum == chat.roomno);   // 내가 이 방의 주인(=내 톡 보는 중)

		// 추천답변 ✅(확인) — 관리자가 보낸 '확인문구'는 말풍선 대신 시스템 라인으로 표시.
		//  (빠른답변의 ✅ 템플릿은 그대로 ✅ 말풍선 — confirmMsg 로만 구분)
		//  전송 자체는 일반 답변과 동일 → 안읽음 '1' 은 정상적으로 사라짐.
		const rawText = (data.body && data.body.text != null) ? data.body.text : data.msg;
		if( isManager && chat.confirmMsg && $.trim(String(rawText || '')) === chat.confirmMsg ) return this.confirmRow(data);

		// 회원 뷰: 어느 관리자가 보냈든 "장비불러" 하나로 합쳐 표시 (단, 로그인 본인 메시지는 제외 — 내 프사/이름 유지)
		const brandAsOne = (!viewerIsAdmin && isManager && !isMe);

		let bonsa = '';
		if( !brandAsOne && chat.bonsaMap[data.sender_num] ) bonsa = ` [${chat.bonsaMap[data.sender_num]}]`;

		// 관리자 뷰는 소속자를 '소유자(소속자)' 로 — 서버가 nameMap 을 관리자에게만 내려준다(회원 뷰는 비어 있음)
		const displayName = brandAsOne ? '장비불러' : (chat.nameMap[data.sender_num] || data.sender_name);
		const groupId     = brandAsOne ? 'mgr' : data.sender_num;

		// 프사(동그라미) — 회원뷰의 관리자(브랜드)는 불러톡 아이콘, 그 외엔 보낸이 프사.
		// 소켓 수신 메세지엔 profile_img 가 없어, 과거목록에서 채운 캐시(avatarMap)로 보완. 둘 다 없으면 이름 첫글자.
		// 관리자 뷰의 관리자는 프사 대신 이름(이니셜)만 — 프사 유무와 무관하게 모두 이름으로 통일.
		let avatarUrl;
		if( brandAsOne ){
			avatarUrl = '/img/jb_logo.png';
		} else if( viewerIsAdmin && !isCustomer ){
			avatarUrl = ''; // 관리자 뷰의 상담원/시스템(방주인 아님) — 프사 대신 이름만
		} else {
			if( data.profile_img ) chat.avatarMap[data.sender_num] = data.profile_img;
			avatarUrl = data.profile_img || chat.avatarMap[data.sender_num] || '';
		}
		const avatarInner = avatarUrl
			? `<img src="${this.escHtml(avatarUrl)}" alt="">`
			: `<span>${this.escHtml(String((brandAsOne ? displayName : data.sender_name) || '').slice(0, 3))}</span>`; // 이니셜은 실제 보낸 사람
		// 자기 톡(내가 방주인)에선 본인 프사 숨김 — 회원 자기톡·관리자 자기톡 모두. (회원 톡을 보는 /adm/chat 은 표시)
		const showAvatar = !(isMe && viewerIsOwner);
		// 아바타 테마: 회원뷰 관리자=브랜드로고, 관리자뷰 고객(유저)=--user, 그 외 관리자=기본(주황)
		//  관리자끼리는 색으로 구분하지 않고(모두 노랑 말풍선) 이름으로 구분한다.
		const avatarCls = 'chat-avatar'
			+ (brandAsOne ? ' chat-avatar--brand' : '')
			+ ((viewerIsAdmin && isCustomer) ? ' chat-avatar--user' : '');
		const avatarEl = showAvatar
			? `<div class="${avatarCls}" data-mbno="${parseInt(data.sender_num) || 0}">${avatarInner}</div>`
			: '';

		// 본문: 구조화 JSON body 로 렌더. body 없는 메시지(부재중 자동답변 등)는 평문(data.msg)으로 폴백.
		const body = (data.body && data.body.t) ? data.body : { t:'text', text:data.msg };
		const message = this.renderBody(body, isManager);

		// 이미지·카드 말풍선은 배경/패딩 제거 (그림이 곧 내용이라 테두리가 군더더기다)
		// 행에도 표식을 단다(chat-row--media) — 사진은 폭이 곧 가독성이라 줄을 더 넓게 쓴다(_chat-room.scss).
		const mediaCls = (body.t === 'img' || body.t === 'cards') ? ' chat-bubble--media' : '';

		// 좌/우 — 내 톡(내가 방주인)일 땐 perspective 기준(나만 우측), 회원 톡을 보는 관리자는 역할 기준(장비불러 전부 우측·회원 좌측)
		const onRight  = viewerIsOwner ? isMe : !isCustomer;
		// 이름 표시 — 회원 자기톡의 내 메시지만 숨김. 관리자 뷰에선 모든 관리자 이름 노출(누가 보냈는지 구분).
		const showName = !(isMe && viewerIsOwner);

		// 색(꼬리 없음) — 위치 기준. 뷰 종류(관리자/회원/iframe)와 무관하게 일관.
		//  · 오른쪽(자기편: 자신 + 같은 편 관리자) = 노랑
		//  · 왼쪽(상대편: 회원이든 다른 관리자든) = 파랑
		const colorCls = onRight ? 'chat-bubble--me' : 'chat-bubble--mgr';

		// 접기 토글 — 긴 관리자 메시지에 접기/펼치기 버튼을 단다. 기본은 펼침(처음부터 전체 표시).
		//  실제 버튼 노출은 렌더 후 높이 측정(applyFold)에서 3줄 초과인 것만. 여기선 후보만 표시.
		const isAdminMsg = isManager; // 관리자(장비불러) 메시지는 좌/우 무관 접기 후보
		const foldable = isAdminMsg && !mediaCls;

		let inner = message, foldCls = '';
		if( foldable ){
			foldCls = ' chat-bubble--foldable';
			inner = `<div class="chat-fold-body">${message}</div>`
				+ `<button type="button" class="js-chat-fold chat-fold">접어두기</button>`;
		}
		// 삭제됨 — 관리자뷰(mode 1)만 원문 위에 빨간 '삭제됨' 태그. 회원뷰(mode 2)는 툼스톤 텍스트만.
		if( deletedMode === 1 ) inner = `<span class="chat-deleted-tag">삭제됨</span>` + inner;

		// 답장 인용 — 말풍선 상단(접힘 영역 밖)에 항상 표시
		// 답장기능 주석처리 — 인용 렌더링 비활성화
		// if( body.reply ) inner = this.replyQuoteHtml(body.reply) + inner;

		const deletedCls = isDeleted ? ' chat-bubble--deleted' : '';
		const bubble = `<div class="chat-bubble ${colorCls}${mediaCls}${foldCls}${deletedCls}">${inner}</div>`;
		const timeEl = `<span class="chat-time">${time}</span>`;

		// 관리자 뷰 — 회원 톡의 '관리자 안읽음'(read_by_admin=0) 표시. 꾹 눌러 토글한다(Index.initHandler).
		//  소켓으로 막 받은 톡엔 read_by_admin 이 없으므로(undefined) 표시하지 않는다 — 지금 보고 있는 톡이다.
		const isUnread = viewerIsAdmin && isCustomer && String(data.read_by_admin) === '0';
		const unreadEl = isUnread ? this.unreadMarkHtml() : '';

		const line   = onRight
			? `<div class="chat-line">${timeEl}${bubble}</div>`  // 오른쪽: 시간 → 말풍선
			: `<div class="chat-line">${bubble}${timeEl}${unreadEl}</div>`; // 왼쪽: 말풍선 → 시간 → 안읽음
		const nameEl = showName ? `<div class="chat-name">${this.escHtml(displayName)}${bonsa}</div>` : '';

		return `
<div class="chat-row ${onRight ? 'chat-row--right' : 'chat-row--left'}${mediaCls ? ' chat-row--media' : ''}" data-mbno="${data.sender_num}" data-num="${parseInt(data.num) || 0}" data-mgr="${isManager ? 1 : 0}" data-deleted="${isDeleted ? 1 : 0}" data-unread="${isUnread ? 1 : 0}" data-name="${this.escHtml(brandAsOne ? displayName : data.sender_name)}" data-group="${groupId}" data-min="${minute}">
	<div class="chat-main">
		${avatarEl}
		<div class="chat-col">
			${nameEl}
			${line}
		</div>
	</div>
</div>`;
	}

	/**
	 * 답장 인용 블록 HTML (말풍선 상단). 클릭 시 원본 메시지로 이동(data-ref=원본 num).
	 *  라벨: "○○에게 답장" — 보는 사람이 원문 작성자면 "나에게 답장".
	 */
	replyQuoteHtml(reply){
		const isMine = (reply.mb && String(reply.mb) === String(this.chat.userNum));
		const label  = isMine ? '나에게 답장' : (reply.name ? `${reply.name}에게 답장` : '답장');
		const nm = this.escHtml(label);
		const tx = this.escHtml(reply.text);
		return `<div class="chat-reply-quote" data-ref="${parseInt(reply.num) || 0}"><span class="chat-reply-quote__name">${nm}</span><span class="chat-reply-quote__text">${tx}</span></div>`;
	}

	/**
	 * 원본 메시지로 스크롤 이동 + 잠깐 강조. (인용 칸 클릭)
	 * 화면에 아직 로딩 안 된 옛 메시지면 조용히 무시.
	 * @param num 원본 메시지 num (chat-row data-num)
	 */
	scrollToMessage(num){
		if( !num ) return;
		const $row = $(`#content_list .chat-row[data-num="${num}"]`).first();
		if( !$row.length ) return;
		const el = $('#talkList_inside')[0];
		if( !el ) return;
		const delta = $row[0].getBoundingClientRect().top - el.getBoundingClientRect().top;
		this._pin = false; // 옛 메시지를 보러 간 것 — 바닥 고정 해제
		el.scrollTop = el.scrollTop + delta - 60; // 상단에서 살짝 띄움
		$row.removeClass('chat-row--flash'); // 재생 보장(리플로우)
		void $row[0].offsetWidth;
		$row.addClass('chat-row--flash');
		setTimeout(() => $row.removeClass('chat-row--flash'), 1400);
	}

	/**
	 * 관리자: 꾹 누른 관리자 메시지 위에 '삭제' 버튼 노출. (한 번에 하나만)
	 * @param $row .chat-row jQuery
	 * @param num  g5_chat_messages.num
	 */
	showDeleteBtn($row, num){
		this.hideDeleteBtn();
		if( !$row || !$row.length || !num ) return;
		const $bubble = $row.find('.chat-bubble').first();
		if( !$bubble.length ) return;
		// 버튼은 말풍선 기준(right:100%)으로 왼쪽 바깥에 배치 → 말풍선 안에 append
		$row.addClass('chat-row--delarm');
		$bubble.append(`<button type="button" class="js-chat-del chat-del-btn" data-num="${parseInt(num) || 0}">삭제</button>`);
	}

	/** 노출된 삭제 버튼 제거 */
	hideDeleteBtn(){
		$('#content_list .chat-del-btn').remove();
		$('#content_list .chat-row--delarm').removeClass('chat-row--delarm');
	}

	/**
	 * 삭제 확인 다이얼로그 → 예 하면 소프트 삭제 요청.
	 * @param num g5_chat_messages.num
	 */
	confirmDeleteMessage(num){
		const chat = this.chat;
		const ok = () => chat.ajax.deleteMessage(num);
		Util.swalert('이 메시지를 삭제하시겠습니까?', ok);
	}

	/**
	 * 특정 메시지를 '삭제된 메시지'로 즉시 교체 (삭제 성공 후 화면 반영).
	 * @param num g5_chat_messages.num
	 */
	markDeleted(num){
		const $row = $(`#content_list .chat-row[data-num="${parseInt(num) || 0}"]`);
		if( !$row.length ) return;
		$row.attr('data-deleted', '1');
		const $b = $row.find('.chat-bubble');
		if( $b.hasClass('chat-bubble--deleted') ) return;   // 이미 표시됨
		$b.addClass('chat-bubble--deleted');                // 원문은 회색, 좌상단 '삭제됨' 태그
		if( !$b.find('.chat-deleted-tag').length ){
			$b.prepend('<span class="chat-deleted-tag">삭제됨</span>');
		}
	}

	/**
	 * 특정 메시지의 '안읽음' 표시를 켜고 끈다 (토글 성공 후 화면 반영).
	 * @param num g5_chat_messages.num
	 * @param on  true=안읽음 표시, false=해제
	 */
	markUnread(num, on){
		const $row = $(`#content_list .chat-row[data-num="${parseInt(num) || 0}"]`);
		if( !$row.length ) return;
		$row.attr('data-unread', on ? '1' : '0');
		const $line = $row.find('.chat-line').first();
		$line.find('.chat-unread-mark').remove();
		if( on ) $line.append(this.unreadMarkHtml());
	}

	/**
	 * 화면의 안읽음 태그를 모두 지운다 — 관리자가 답장하면 서버가 방 전체를 읽음으로 털기 때문에
	 * (ChatMessageService::send 의 isGuest 분기) 화면도 같이 맞춘다.
	 */
	clearUnreadMarks(){
		$('#content_list .chat-unread-mark').remove();
		$('#content_list .chat-row[data-unread="1"]').attr('data-unread', '0');
	}

	/** 안읽음 태그 — 누르면 읽음으로 해제된다(그래서 ✕ 를 달았다). 최초 렌더와 토글이 같은 HTML 을 쓴다. */
	unreadMarkHtml(){
		return '<span class="chat-unread-mark js-chat-unread" title="누르면 읽음으로 되돌립니다">안읽음 <b>✕</b></span>';
	}

	/**
	 * 꾹 누른 말풍선을 답장 대상으로 지정 — 입력창 위 인용 미리보기 표시.
	 * @param $bubble .chat-bubble jQuery
	 */
	armReply($bubble){
		const chat = this.chat;
		const $row = $bubble.closest('.chat-row');
		if( !$row.length ) return;

		const num  = $row.data('num');
		const name = String($row.data('name') || '');               // 저장/인용용 = 실제 이름(상대방도 봐야 정확)
		const senderNum = parseInt($row.data('mbno')) || 0;          // 원문 작성자 번호(인용 라벨 '나' 판정용)
		const isMine = (String(senderNum) === String(chat.userNum)); // 내가 보낸 메시지인가
		let text;
		if( $bubble.find('.js-chat-image').length )      text = '[사진]';
		else if( $bubble.find('.chat-audio').length )    text = '[음성]';
		else {
			const $src = $bubble.children('.chat-fold-body').length ? $bubble.children('.chat-fold-body') : $bubble;
			const $clone = $src.clone();
			$clone.find('.chat-reply-quote, .js-chat-fold, .js-chat-order').remove();
			text = $clone.text().replace(/\s+/g, ' ').trim();
		}
		if( !text ) text = '[메시지]';

		chat.replyTo = { num, name, text, mb: senderNum };
		const $bar = $('#chatReplyBar');
		// 미리보기 라벨만 본인이면 "나에게 답장" (저장되는 name 은 실제 이름 그대로)
		const label = isMine ? '나에게 답장' : (name ? `${name}에게 답장` : '답장');
		$bar.find('.chat-reply-bar__name').text(label);
		$bar.find('.chat-reply-bar__text').text(text); // 원문 전체 — 길면 CSS 말줄임(…)
		$bar.css('display', 'flex');
		this.positionReplyBar();         // 입력창 바로 위에 고정 배치
		this.resizeScroll();             // 입력영역 높이 변동 → 스크롤 컨테이너 재계산
		$('#sendmessagcont').focus();
	}

	/** 답장 모드 해제 */
	cancelReply(){
		this.chat.replyTo = null;
		$('#chatReplyBar').hide();
		this.resizeScroll();
	}

	/**
	 * 긴 관리자 메시지 접기 토글 — 렌더 후 높이를 재서 3줄(미리보기)을 넘는 것만 접기 버튼 활성화.
	 * 3줄 이하면 접을 게 없으니 버튼 제거(일반 표시). 기본은 펼침(data-fold-default 없으면 collapse=false).
	 */
	applyFold(){
		$('#content_list .chat-bubble--foldable').each(function(){
			const $bub = $(this);
			if( $bub.data('fold-done') ) return; // 1회만 측정
			$bub.data('fold-done', 1);

			const body = $bub.children('.chat-fold-body')[0];
			if( !body ) return;

			let lineH = parseFloat(getComputedStyle(body).lineHeight);
			if( isNaN(lineH) ) lineH = 21;
			const max = lineH * 3; // 3줄 미리보기 높이

			if( body.scrollHeight <= max + 4 ){ // 3줄 이하 — 접기 불필요
				$bub.removeClass('chat-bubble--foldable');
				$bub.children('.chat-fold').remove();
				return;
			}
			// 화면 넘는 길이 → 접기 버튼 활성화. 기본값은 쿠키(마지막 접기 선택) 유지, 쿠키 없으면 펼침.
			$bub.addClass('chat-bubble--collapsible');
			const collapse = (Store.cookie.get('chat_fold_collapsed') === '1');
			$bub.toggleClass('is-collapsed', collapse);
			$bub.children('.chat-fold').text(collapse ? '펼쳐보기' : '접어두기');
		});
	}

	/**
	 * 연속 메세지 그룹핑 — 같은 그룹(data-group)·같은 분(data-min)이 연속이면
	 * 두번째부터 이름 숨김(chat-row--grouped), 시간은 그룹 마지막에만(chat-row--hide-time).
	 */
	groupRows(){
		const rows = $('#content_list > .chat-row').toArray();
		const keyOf = (el) => el ? ($(el).attr('data-group') + '|' + $(el).attr('data-min')) : null;
		rows.forEach((el, i) => {
			const key = keyOf(el);
			$(el).toggleClass('chat-row--grouped', i > 0 && key === keyOf(rows[i - 1]));
			$(el).toggleClass('chat-row--hide-time', i < rows.length - 1 && key === keyOf(rows[i + 1]));
		});
	}

	/**
	 * 입력 유무로 전송버튼 활성화 토글.
	 */
	showSendBtn(){
		const hasText = $.trim($('#sendmessagcont').val()).length > 0;
		$('#send_callbtn').toggleClass('is-on', hasText);
	}

	/**
	 * 입력창 높이 자동확장(한 줄 → 여러 줄, 최대 165px=7줄).
	 * @param el textarea 엘리먼트
	 */
	autoGrow(el){
		if( !el ) return;
		const max = 165; // _chat-room.scss max-height 와 일치
		el.style.height = 'auto';                       // 줄어들 때 위해 초기화
		el.style.height = Math.min(el.scrollHeight, max) + 'px';
		this.positionReplyBar();                        // 입력창 높이 변동 → 답장 바 위치 추적
		this.positionAbsentBanner();                    // 입력창 높이 변동 → 에티켓 배너 위치 추적
		this.positionTray();                            // 입력창 높이 변동 → 추천/빠른답변 트레이 위치 추적
		this.positionTyping();                          // 입력창 높이 변동 → 입력중 표시 위치 추적
	}

	/** 답장 바(fixed)를 입력창 바로 위에 위치시킴 (입력창 높이에 동기화) */
	positionReplyBar(){
		const $bar = $('#chatReplyBar');
		if( !$bar.length || $bar.css('display') === 'none' ) return;
		$bar.css('bottom', ($('#keyinputBoxdiv').outerHeight() || 0) + 'px');
	}
}